import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  TextField as MuiTextField,
} from "@mui/material";
import { Field, Form } from "react-final-form";

import { TextField } from "~ui/atoms/Form/TextField/TextField";

const tAddContact = "Add Contact";
const tEditContact = "Edit Contact";
const tCancel = "Cancel";
const tAdd = "Add";
const tSave = "Save";
const tFirstName = "First Name";
const tLastName = "Last Name";
const tEmail = "Email";
const tPhone = "Phone";
const tRoleTitle = "Role Title";
const tPrimaryContact = "Primary Contact";

interface AddContactModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    roleTitle?: string;
    isPrimary?: boolean;
  }) => Promise<void>;
  initialValues?: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    roleTitle?: string;
    isPrimary?: boolean;
  };
  isEdit?: boolean;
}

export const AddContactModal = ({
  open,
  onClose,
  onSubmit,
  initialValues = {},
  isEdit = false,
}: AddContactModalProps) => {
  const handleSubmit = async (values: {
    firstName?: string;
    lastName?: string;
    email?: string;
    phone?: string;
    roleTitle?: string;
    isPrimary?: boolean;
  }) => {
    await onSubmit(values);
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <Form
        onSubmit={handleSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, submitting, hasValidationErrors, errors }) => (
          <form onSubmit={handleSubmit}>
            <DialogTitle>{isEdit ? tEditContact : tAddContact}</DialogTitle>
            <DialogContent>
              <Box display="grid" gap={2} py={1}>
                <TextField
                  name="firstName"
                  required
                  validate={(value) => (!value ? "Required" : undefined)}
                  textFieldProps={{
                    label: tFirstName,
                  }}
                />
                <TextField
                  name="lastName"
                  required
                  validate={(value) => (!value ? "Required" : undefined)}
                  textFieldProps={{
                    label: tLastName,
                  }}
                />
                <Field name="email">
                  {({ input }) => <MuiTextField {...input} fullWidth label={tEmail} type="email" />}
                </Field>
                <Field name="phone">
                  {({ input }) => <MuiTextField {...input} fullWidth label={tPhone} type="tel" />}
                </Field>
                <TextField
                  name="roleTitle"
                  required
                  validate={(value) => (!value ? "Required" : undefined)}
                  textFieldProps={{
                    label: tRoleTitle,
                  }}
                />
                <Field name="isPrimary" type="checkbox">
                  {({ input }) => <FormControlLabel control={<Checkbox {...input} />} label={tPrimaryContact} />}
                </Field>
              </Box>
            </DialogContent>
            <DialogActions>
              <Button onClick={onClose}>{tCancel}</Button>
              <Button
                type="submit"
                variant="contained"
                disabled={submitting || hasValidationErrors || Object.keys(errors || {}).length > 0}
              >
                {isEdit ? tSave : tAdd}
              </Button>
            </DialogActions>
          </form>
        )}
      />
    </Dialog>
  );
};
